import { useState, MouseEvent } from 'react';
import { styled } from '@mui/material/styles';
import { Box, ListItemIcon, Typography } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Logo from 'components/Logo';
import { setDefaultOptions, format } from 'date-fns';
import { el } from 'date-fns/locale';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { useAuth } from 'react-oidc-context';
import BranchSelector from './BranchSelector';

setDefaultOptions({ locale: el });

const ProfileButton = styled(Button)({
  color: 'inherit',
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  backgroundColor: 'initial',
  borderColor: 'none',
  '&:hover': {
    backgroundColor: 'initial',
    borderColor: 'none',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: 'initial',
    borderColor: 'none',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});

const ProfileMenuItem = styled(MenuItem)(({ theme }) => ({
  '&:hover .MuiListItemIcon-root': {
    color: theme.palette.secondary.main,
  },
}));

const Header = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const auth = useAuth();

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar
      position="fixed"
      color="primary"
      elevation={0}
      sx={{
        borderBottom: theme => `1px solid ${theme.palette.divider}`,
        zIndex: theme => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar sx={{ flexWrap: 'wrap' }} disableGutters>
        <Logo />
        <Box sx={{ flexGrow: 1 }} />
        <Box sx={{ display: { xs: 'none', sm: 'none', md: 'flex' }, alignItems: 'center', gap: 2 }} px={2}>
          <BranchSelector variant="header" />
          <Box textAlign="right">
            Καλώς ήρθες,
            <ProfileButton
              disableRipple
              id="profile-button"
              aria-controls={open ? 'profile-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
              disableElevation
              endIcon={<KeyboardArrowDown />}
              style={{
                textTransform: 'inherit',
                fontSize: '1rem',
              }}
            >
              <b>{auth.user!!.profile.name}</b>
            </ProfileButton>
            <Menu
              id="profile-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              slotProps={{
                list: {
                  'aria-labelledby': 'profile-button',
                },
              }}
            >
              <ProfileMenuItem
                onClick={() => {
                  handleClose();
                  auth.signoutRedirect();
                }}
              >
                <ListItemIcon>
                  <LogoutOutlinedIcon fontSize="small" />
                </ListItemIcon>
                <Typography variant="inherit">Αποσύνδεση</Typography>
              </ProfileMenuItem>
            </Menu>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
